// consistent with upload_image api in current infograph backend
export const ALLOW_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif'];
export const ALLOW_IMAGE_SIZE_MB = 10;
export const ALLOW_IMAGE_SIZE = ALLOW_IMAGE_SIZE_MB * 1024 * 1024;

export const S3_IMAGE_BUCKET_LINK = process.env.REACT_APP_S3_IMAGE_BUCKET_LINK;
export const S3_USER_MEDIA_BUCKET_LINK = process.env.REACT_APP_S3_USER_MEDIA_BUCKET_LINK;

// use 6 to be consistent with the number of parallel connections for most browsers
// [Ref](https://www.tutorialspoint.com/what-are-max-parallel-http-connections-in-a-browser#:~:text=Browser%20connection%20limitations&text=Six%20connections%20per%20domain%20are,to%20the%20HTTP%201.1%20protocol.)
export const BATCH_UPLOAD_FILE_NUMBER_LIMIT = 6;
